<template>
  <div
    class="gps-mode-selector-section"
    :class="`gps-mode-selector-section--${screenOrientationType}`"
  >
    <button
      class="gps-mode-selector-section__button"
      :class="{ 'gps-mode-selector-section__button--current': gpsViewMode === 'birdsEye' }"
      @click="onclickSelector('birdsEye')"
    >
      <span>{{ $t('RaceVideoPage.GPS.selector.birdsEye') }}</span>
    </button>
    <button
      class="gps-mode-selector-section__button"
      :class="{ 'gps-mode-selector-section__button--current': gpsViewMode === 'battle' }"
      @click="onclickSelector('battle')"
    >
      <span>{{ $t('RaceVideoPage.GPS.selector.battle') }}</span>
    </button>
    <button
      class="gps-mode-selector-section__button"
      :class="{ 'gps-mode-selector-section__button--current': gpsViewMode === 'focus' }"
      @click="onclickSelector('focus')"
    >
      <span>{{ $t('RaceVideoPage.GPS.selector.focus') }}</span>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { GpsViewModeType } from '@/components/RaceVideoPage/RaceVideoGpsPane.vue'

/**
 * レース動画再生画面: GPS詳細 表示モードセレクター
 */
export default defineComponent({
  name: 'GpsViewModeSelectorSection',
  components: {},
  props: {
    /**
     * GPS表示モード
     */
    gpsViewMode: {
      type: String as PropType<GpsViewModeType>,
      default: 'birdsEye',
    },
    /**
     * 画面向き
     */
    screenOrientationType: {
      type: String,
      default: 'portrait-primary',
    },
  },
  setup() {
    return {}
  },
  methods: {
    onclickSelector(changeMode: GpsViewModeType): void {
      /**
       * GPS詳細表示モード変更
       * @param changeMode
       */
      if (this.gpsViewMode === changeMode) return

      this.$emit('onclickSelector', changeMode)
    },
  },
})
</script>

<style lang="scss" scoped>
.gps-mode-selector-section {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: calc(100vw - 32px);
  max-width: 328px;
  margin: 0 auto;
  background: rgba(31, 31, 31, 0.9);
  border-radius: 8px;
  overflow: hidden;

  &__button {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 32px;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.33;
    letter-spacing: 0.04em;
    color: $gray20;
    text-align: center;

    &--current {
      color: $green-light;
      background: rgba(0, 219, 166, 0.5);
    }
  }

  &--landscape-primary,
  &--landscape-secondary {
    width: calc(100% - 8px);
    max-width: none;

    .gps-mode-selector-section {
      &__button {
        font-size: 10px;
      }
    }
  }
}
</style>
